import React from 'react';
import Link from '../utils/link';
import parse from 'html-react-parser';

const TitleContentCta = ({title, content, largeText, link}) => (
  <section className="title-content-cta">
    <div className="title-content-cta__inner">
      <div className="title-content-cta__left">
        <h4>{title}</h4>
        {parse(content)}
      </div>

      <div className="title-content-cta__right">
        <h2>{largeText}</h2>
        {parse(content)}
        { link?.url &&
          <Link className="btn btn--white" to={link.url}>
            {link.title}
          </Link>
        }
      </div>
    </div>
  </section>
);

TitleContentCta.defaultProps = {
  title: ``,
  content: ``,
  largeText: ``,
  link: null,
};

export default TitleContentCta;